import Wrapper from "../../../layout/Wrapper";
import AgentCommissionReportComponent from "../../../screens/reports/agentCommission";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Agent Commission Report",
	description: "",
};

export default function AgentCommissionReport() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<AgentCommissionReportComponent />
		</Wrapper>
	);
}